if (!customElements.get('product-tabs')) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();

      this.buttons = [];
      this.tabs = [];
      this.productAddToCartButtons = [];
      this.indicator = [];
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('.product-tabs__nav-button');
      this.tabs = this.querySelectorAll('.product-tab');
      this.productAddToCartButtons = this.querySelectorAll('.product-tab .card .button');
      this.indicator = this.querySelector('.product-tabs__nav-indicator');

      this.handleClick = this.handleClick.bind(this);

      this.init();
    }

    init() {
      this.buttons.forEach(button => {
        button.addEventListener('click', this.handleClick);
      });

      this.productAddToCartButtons.forEach(button => {
        button.addEventListener('click', this.handleAddToCartClick.bind(this));
      });

      // Initialize default active state
      const activeBtn = this.querySelector('.product-tabs__nav-button.active');
      if (activeBtn) {
        this.filterTabs(activeBtn.dataset.target);
      }
    }

    handleClick(event) {
      const button = event.currentTarget;
      const target = button.dataset.target;

      this.setActiveButton(button);
      this.filterTabs(target);
    }

    handleAddToCartClick(event) {
      event.preventDefault();

      const button = event.currentTarget;
      const productId = button.dataset.productId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1
        })
      });
    }

    setActiveButton(activeButton) {
      this.buttons.forEach(btn => btn.classList.remove('active'));
      activeButton.classList.add('active');
    }

    filterTabs(target) {
      this.tabs.forEach(tab => {
        const isMatch = tab.dataset.tab === target;
        tab.classList.toggle('active', isMatch);
      });
    }

    disconnectedCallback() {
      // cleanup (important in Shopify dynamic sections)
      this.buttons.forEach(button => {
        button.removeEventListener('click', this.handleClick);
      });
    }
  }

  customElements.define('product-tabs', ProductTabs);
}